import React from 'react';

import AlertPanel from 'components/generic/AlertPanel.component';
import Icon from 'components/generic/Icon.component';

import CN from './UiPage.module.scss'; // Since this is experiment, we can share the same .module.scss file

const AlertsPanel = () => (
  <div data-bem="AlertPanel" className={CN.container}>
    <div className={CN.container}>
      <div className={CN.verticalFlex}>
        <div className={CN.title}>
          <strong>
            Variant success <small>position is optional - centerTopFixed</small>
          </strong>
        </div>
        <br />
        <AlertPanel tag="AlertPanel__alert-success" variant="success">
          <Icon variant="confirm" width="lg" />
          variant="success"
        </AlertPanel>
        <br />

        <AlertPanel tag="AlertPanel__alert-warning" variant="danger">
          <Icon variant="warning" />
          variant="danger"
        </AlertPanel>
        <br />
        <AlertPanel tag="AlertPanel__alert-warning" variant="warningPanel" variantInvert>
          <Icon variant="warning" />
          variant="warningPanel" variantInvert
        </AlertPanel>
        <br />
        <AlertPanel tag="AlertPanel__alert-warning" variant="warningPanel">
          <Icon variant="warning" />
          variant="warningPanel"
        </AlertPanel>
        <br />

        <AlertPanel tag="AlertPanel__alert-primary" variant="alert">
          variant="alert"
        </AlertPanel>
        <br />

        <AlertPanel tag="AlertPanel__alert-primary" variant="primary">
          <Icon variant="lock" width="lg" />
          variant="primary"
        </AlertPanel>
        <br />
        <AlertPanel tag="AlertPanel__alert-primaryV2" variant="primaryV2">
          <Icon variant="lock" width="lg" />
          variant="primaryV2
        </AlertPanel>
        <br />
        <AlertPanel tag="AlertPanel__alert-error" variant="error">
          variant="error"
        </AlertPanel>
        <br />
        <AlertPanel tag="AlertPanel__alert-warning" variant="warning">
          variant="warning
        </AlertPanel>
        <br />
        <AlertPanel tag="AlertPanel__alert-inactive" variant="inactive">
          variant="inactive
        </AlertPanel>
        <br />
        <AlertPanel tag="AlertPanel__alert-passed" variant="passed">
          variant="passed
        </AlertPanel>
        <br />

        <AlertPanel tag="AlertPanel__alert-slick" variant="slick">
          <div className={CN.flex}>
            <div className={CN.alertContainer}>
              <Icon tag="PaymentTabs__users" variant="star" width="xl" />
              <div className={CN.alertText}>
                <span className={CN.extraBold}> variant="slick"</span> - bla bla bla
              </div>
            </div>
          </div>
        </AlertPanel>
      </div>
    </div>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default AlertsPanel;
